import { gql } from '@apollo/client';

export const GET_NODES_LIST = gql`
  query Nodes($params: FindNodeListInput!) {
    nodes(params: $params) {
      success
      message
      errors
      data {
        nodes {
          id
          code
          name
          keywords
          semanticWeight
          order
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_NODE = gql`
  query Node($params: FindNodeInput!) {
    node(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        keywords
        semanticWeight
        order
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
